export const persistedName = "project_qa_welding_inspections_new";
